const getSsoToken = async () => {
    if (!window.riskalive || !window.riskalive.sso) return null;
    for (let i = 0; i < 3; i++) {
        const token = await window.riskalive.sso.getToken();
        if (token) return token;
        await new Promise(r => setTimeout(r, 200));
    }
    return null;
};

const upload = async (streamRef, fileName, contentType, conversationId, vectorStoreId, baseUrl) => {
    try {
        const arrayBuffer = await streamRef.arrayBuffer();
        const blob = new Blob([arrayBuffer], { type: contentType || 'application/octet-stream' });
        const formData = new FormData();
        formData.append('file', blob, fileName);
        formData.append('conversationId', conversationId);
        if (vectorStoreId) formData.append('vectorStoreId', vectorStoreId);

        const headers = {};
        const token = await getSsoToken();
        if (token) headers['Authorization'] = 'Bearer ' + token;

        const resp = await fetch((baseUrl || '') + '/api/chat/files', {
            method: 'POST',
            headers,
            body: formData,
        });
        const text = await resp.text();
        return JSON.stringify({ status: resp.status, body: text });
    } catch (e) {
        return JSON.stringify({ status: 0, body: (e && e.message) || String(e) });
    }
};

const remove = async (vectorStoreId, foundryFileId, blobContainer, blobName, baseUrl) => {
    try {
        const headers = { 'Content-Type': 'application/json' };
        const token = await getSsoToken();
        if (token) headers['Authorization'] = 'Bearer ' + token;

        const resp = await fetch((baseUrl || '') + '/api/chat/files/delete', {
            method: 'POST',
            headers,
            body: JSON.stringify({ vectorStoreId, foundryFileId, blobContainer, blobName }),
        });
        const text = await resp.text();
        return JSON.stringify({ status: resp.status, body: text });
    } catch (e) {
        return JSON.stringify({ status: 0, body: (e && e.message) || String(e) });
    }
};

export default { upload, remove };
